<template>
<div class="userinfoshow">
    <user-title :msg="msg" />
    <delete-user-show></delete-user-show>
</div>
  
</template>

<script>
import DeleteUserShow from './DeleteUserShow.vue'
import UserTitle from './UserTitle.vue'
export default {
  data(){
    return{
      msg:"注销账号"
    }
  },
  components: { UserTitle, DeleteUserShow },

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/user/DeleteUser.vue